/**
 * 日付回答の正本フォーマットは "YYYY/MM/DD"。
 * 入力は UI 側でネイティブのカレンダーピッカーに限定する (手打ち不可) が、
 * 音声/AI 抽出経路は任意の文字列を返しうるため、保存前にここで正規化・検証する。
 */

/** "2026/7/1" "2026-07-01" "2026.7.1" "2026年7月1日" → "2026/07/01"。不正・非実在日は undefined。 */
export const normalizeDate = (raw: string): string | undefined => {
  const m = /^(\d{4})\s*[/\-.年]\s*(\d{1,2})\s*[/\-.月]\s*(\d{1,2})\s*日?$/.exec(raw.trim());
  if (!m) return undefined;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const dt = new Date(Date.UTC(y, mo - 1, d));
  // 2026/02/30 のような非実在日は Date が繰り上げるので、往復で一致するものだけ通す。
  if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== mo - 1 || dt.getUTCDate() !== d) return undefined;
  return `${y}/${String(mo).padStart(2, "0")}/${String(d).padStart(2, "0")}`;
};

/** 正本フォーマット (ゼロ埋め済み "YYYY/MM/DD" かつ実在日) か。 */
export const isValidDate = (raw: string): boolean => normalizeDate(raw) === raw.trim();
